import React from 'react'
import PropTypes from 'prop-types'

import Glyph from 'component/utils/Glyph'

import CheckboxAltChecked from 'images/checkbox-alt-checked.svg'
import CheckboxAltUnchecked from 'images/checkbox-alt-unchecked.svg'
import CheckboxAltMid from 'images/checkbox-alt-mid.svg'

const Table = ({
  cdMissionList,
  handleResize,
  openModal,
  records,
  setCdMissionList,
  translate,
}) => {
  const renderHeader = () => {
    let src = CheckboxAltUnchecked

    let setAll = true

    const cdMissionListLength = cdMissionList.length

    if (cdMissionListLength) {
      if (cdMissionListLength < records.length) {
        src = CheckboxAltMid
      } else {
        src = CheckboxAltChecked

        setAll = false
      }
    }

    return (
      <tr>
        <th
          onClick={() =>
            setCdMissionList(setAll ? records.map((i) => i.cdMission) : [])
          }
          className='text-align-center'
        >
          <img src={src} />
        </th>
        <th>{translate('stockTransfer.missionBlock.table.header.mission')}</th>
        <th>{translate('stockTransfer.missionBlock.source')}</th>
        <th>{translate('stockTransfer.missionBlock.destination')}</th>
        <th className='text-align-center'>{translate('edit_button_label')}</th>
      </tr>
    )
  }

  const renderBody = () => {
    handleResize()

    const renderDepositList = (list) => {
      if (!list.length) return '-'

      return list.map((deposit) => deposit.idDeposit).join(', ')
    }

    const renderRecord = (record) => {
      const { cdMission } = record

      const checked = cdMissionList.some((item) => item === cdMission)

      return (
        <tr key={cdMission}>
          <td
            onClick={() =>
              setCdMissionList(
                checked
                  ? cdMissionList.filter((i) => i !== cdMission)
                  : [...cdMissionList, cdMission]
              )
            }
            className='text-align-center'
          >
            <img src={checked ? CheckboxAltChecked : CheckboxAltUnchecked} />
          </td>
          <td>{record.dsMission}</td>
          <td>{renderDepositList(record.sourceDepositList)}</td>
          <td>{renderDepositList(record.destinationDepositList)}</td>
          <td className='mission-block-edit-icon'>
            <Glyph
              type='pencil'
              color='primary'
              onClick={() => openModal(record)}
            />
          </td>
        </tr>
      )
    }

    return records.map(renderRecord)
  }

  return (
    <table cellPadding={0} cellSpacing={0} className='mission-block-table'>
      <thead>{renderHeader()}</thead>
      <tbody>{renderBody()}</tbody>
    </table>
  )
}

Table.propTypes = {
  cdMissionList: PropTypes.array.isRequired,
  handleResize: PropTypes.func.isRequired,
  openModal: PropTypes.func.isRequired,
  records: PropTypes.array.isRequired,
  setCdMissionList: PropTypes.func.isRequired,
  size: PropTypes.number.isRequired,
  translate: PropTypes.func.isRequired,
}

export default Table
